import { render, staticRenderFns } from "./BoxModal.vue?vue&type=template&id=ef83d8fe&scoped=true&"
import script from "./BoxModal.vue?vue&type=script&lang=js&"
export * from "./BoxModal.vue?vue&type=script&lang=js&"
import style0 from "./BoxModal.vue?vue&type=style&index=0&id=ef83d8fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef83d8fe",
  null
  
)

export default component.exports